module.exports = __webpack_public_path__ + "static/bg-1984-2-cc55fd986a9c725ccd084ba1139f866b.png";